export class AuthResultFromServer{
    userExist!: boolean
    passwordCorrect!: boolean
    token!: string
    expiresIn!: string
}